import { connect } from "react-redux";
import { Container, P, Ul, Li, Title } from "./style";

const Faq = ({ theme }) => {
  return (
    <>
      <Container className="mx-2 my-3 text-right">
        <P theme={theme}>
          کاربر گرامی جهت استفاده بهینه از خدمات کاربردی سایت و سرویس‌دهی در شأن
          شما مشتری عزیز لطفا پیش از ثبت سفارش موارد زیر را مطالعه نمایید:
        </P>
        <Title theme={theme}>حریم خصوصی</Title>
        <Ul>
          <Li className="mb-2" theme={theme}>
            1. ما در رستوران رُبانزو از تمامی اطلاعات کاربری مشتریان خود محافظت
            می کنیم، و این اطلاعات را در اختیار شخص حقیقی و حقوقی ثالثی قرار نمی
            دهیم، مگر به دستور مراجع ذی صلاح قضایی.
          </Li>
          <Li className="mb-2" theme={theme}>
            2. ما تعهد می دهیم که از اطلاعات کاربران تنها در راستای ارائه بهتر
            خدمات رستوران رُبانزو استفاده کنیم و اطلاعات کاربران اعم از آدرس،
            شماره تماس، رفتار سفارش آنلاین غذای ایشان را تحت هیچ عنوان دیگری
            استفاده نکنیم.
          </Li>
          <Li className="mb-2" theme={theme}>
            3. ما برای اطلاع رسانی خدمات و ترویج سرویس رستوران رُبانزو حق
            استفاده از اطلاعات کاربران را برای خود محفوظ می دانیم.
          </Li>
        </Ul>
        <Title theme={theme}>حساب کاربری</Title>
        <Ul>
          <Li className="mb-2" theme={theme}>
            1. ثبت نام و سفارش آنلاین از مجموعه رستوران رُبانزو به معنای آگاه
            بودن و پذیرفتن شرایط و قوانین است
          </Li>
          <Li className="mb-2" theme={theme}>
            2. هنگام سفارش، ثبت یک شماره موبایل معتبر و قابل دسترسی برای کاربر
            الزامی است.
          </Li>
          <Li className="mb-2" theme={theme}>
            3. مسئولیت وارد کردن اطلاعات اشتباه از قبیل نام و نام خانوادگی، آدرس
            و شماره تماس، به عهده کاربر است. در صورتی که کاربر اطلاعات خود را
            اشتباه ثبت کند، و به موجب آن، وقفه یا تاخیری در ارسال سفارش به وجود
            آید، هزینه سفارش و ارسال غیر قابل بازگشت خواهد بود.
          </Li>
        </Ul>
        <Title theme={theme}>ثبت سفارش</Title>
        <Ul>
          <Li className="mb-2" theme={theme}>
            1. هنگامی که این مجموعه سفارش شما را دریافت کرد، در صورت نیاز ممکن
            است از طریق تماس تلفنی با شما تماس گرفته شود؛ در صورت عدم پاسخگویی،
            احتمال کنسلی سفارش شما وجود خواهد داشت و در این صورت مبلغ پرداخت شده
            به عنوان اعتبار در حساب کاربری شما منظور خواهد شد.
          </Li>
          <Li className="mb-2" theme={theme}>
            2. زمانی که سفارش ثبت و تایید می گردد، به هیچ وجه امکان لغو و کنسلی
            آن وجود ندارد. با توجه به این که تمام آیتم‌ها شامل مواد غذایی می
            باشند که به دلیل مسائل بهداشتی امکان عودت آنها وجود ندارد، لذا به
            هیچ وجه و تحت هیچ شرایطی (حتی عدم تحویل سفارش از جانب مشتری) سفارش و
            وجه مربوط به آن مسترد نخواهد شد.
          </Li>
          <Li className="mb-2" theme={theme}>
            3. مشتری متعهد می گردد که موقعیت مکانی خود را در زمان ثبت سفارش به
            درستی ثبت نماید، در غیر این صورت این مجموعه مجاز به کنسل کردن سفارش
            و یا دریافت مابه‌التفاوت هزینه ارسال غذا، در زمان تحویل سفارش به
            مشتری است.
          </Li>
          <Li className="mb-2" theme={theme}>
            4. چنانچه کاربر در حین سفارش در آدرسی که مشخص کرده است حضور نداشته
            باشد سفارش به هیچ عنوان به محل دیگری غیر از آدرس مشخص شده در فاکتور
            تحویل داده نخواهد شد و مسئولیت تمامی مشکلاتی که از این طریق پیش
            خواهد آمد بر عهده کاربر خواهد بود.
          </Li>
          <Li className="mb-2" theme={theme}>
            5. جهت استفاده از تخفیف در رستوران رُبانزو باید روش پرداخت آنلاین و
            اعتباری انتخاب شود و این خدمات بر روی سفارشات نقدی اعمال نمی شود.
          </Li>
          <Li className="mb-2" theme={theme}>
            6. چنانچه کاربر کد تخفیفی از مجموعه دریافت و روی سفارشی اعمال کرد،
            اگر به هر دلیل در نهایت سفارش لغو گردد، فقط و فقط وجه پرداختی عودت
            می گردد و مبلغی که در قالب کد بر روی سفارش اعمال شده، مجدد به همان
            شکل قابل استفاده می باشد.
          </Li>
          <Li className="mb-2" theme={theme}>
            7. در مواردی که کاربر در زمان ثبت سفارش، پیام 'آدرس شما خارج از
            محدوده سرویس دهی است' را دریافت می‌کند، سفارش به صلاحدید مجموعه توسط
            پیک و یا آژانس ارسال می گردد و هزینه آن متناسب با فاصله محل دریافت
            سفارش از مجموعه در آدرس تحویل سفارش دریافت می گردد.
          </Li>
          <Li className="mb-2" theme={theme}>
            8. پرداخت وجه از طریق درگاه بانکی، نقدی و کارتخوان در سایت و
            اپلیکیشن امکان پذیر است ولی مجموعه بنا به صلاحدید در مواقعی ممکن است
            اقدام به غیر فعال کردن روش نقدی و کارتخوان کند.
          </Li>
          <Li className="mb-2" theme={theme}>
            9. در شرایط بحرانی فعلی با توجه به امکان شیوع سریع ویروس کرونا،
            مجموعه رستوران رُبانزو مختار است سفارشات حضوری مشتریانی که در هنگام
            ثبت و یا تحویل سفارش از ماسک استفاده نمی‌کنند را کنسل نماید.
          </Li>
        </Ul>
        <Title theme={theme}>پیگیری سفارش ها و مشکلات</Title>
        <Ul>
          <Li className="mb-2" theme={theme}>
            1. پیگیری سفارش ها و مشکلات سایت و اپلیکیشن این مجموعه از طریق تماس
            با شماره تماس (91001770-035) یا ارسال به ایمیل info@robanzo.co امکان
            پذیر است.
          </Li>
          <Li className="mb-2" theme={theme}>
            2. با توجه به اینکه پرداخت آنلاین از طریق درگاه‌های معتبر بانکی
            انجام می شود در صورت مشکل یا اختلال در سیستم بانکی، وجه پرداختی طبق
            روال‌های بانکی و صرفا از طریق بانک عامل مسترد خواهد شد.
          </Li>
          <Li className="mb-2" theme={theme}>
            3. زمان آماده سازی و مدت زمان ارسال غذا که پس از ثبت سفارش به کاربر
            نمایش داده می شود، تقریبی است و در صفحه وضعیت سفارش به همراه اطلاعات
            کامل فاکتور نمایش داده خواهد شد.
          </Li>
        </Ul>
        <P theme={theme}>
          در هر بازدید شما، این امکان وجود دارد که این قوانین اصلاح و یا به روز
          شده باشند. لذا توصیه می شود برای هر بار استفاده از وب سایت مجددا
          قوانین سایت را مطالعه نمایید.
        </P>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Faq);
